import { useReport } from './hooks/use-context';

export function Pictures() {
  const { body } = useReport();

  const parseUrl = (url?: string | null) => {
    if (!url) return '';
    return url.replace('s3.amazonaws.com/', '');
  };

  const images = body?.sections
    ?.flatMap((sectionGroup) => sectionGroup.questions || [])
    ?.filter((question) => question?.type === 'radio')
    ?.flatMap((question) => {
      return question.child_questions
        ?.filter((child) => child.type === 'picture')
        ?.map((child) => ({
          name: question.name,
          url: child?.answers?.[0]?.content
            ? JSON.parse(child.answers[0].content)?.[0]
            : null,
        }));
    })
    ?.filter((child) => Boolean(child?.url));

  if (!images || images.length === 0) return null;

  return (
    <div style={{ breakInside: 'avoid' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '0.5rem',
          fontWeight: 'bold',
          fontSize: '1.2rem',
        }}
      >
        REGISTRO FOTOGRÁFICO
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          backgroundColor: '#ffffcc',
          padding: '1rem',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {images.map(
          (item, idx) =>
            item?.url && (
              <div
                key={idx}
                style={{
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                    maxHeight: '300px',
                  }}
                  crossOrigin="anonymous"
                  src={parseUrl(item.url)}
                  alt="img"
                />
                {item?.name && (
                  <div style={{ marginTop: '0.5rem', fontWeight: 'bold' }}>
                    {item.name}
                  </div>
                )}
              </div>
            ),
        )}
      </div>
    </div>
  );
}
